<template>
  <entity-detail-layout
    icon="fas fa-shield-alt"
    :status="roleData.enabled"
    :title="roleName"
    :subtitle="`Rol ${roleId}`"
    :registered-at="registeredAt"
    :details="headerDetails"
    :loading="isLoading"
    :on-back="goBack"
  >
    <entity-tabs
      :tabs="tabs"
      :active-key="tabActive"
      @change="changeTab"
    />

    <role-session-policies
      v-if="tabActive === 'session-policies'"
      :role="roleData.code"
      :role-session-config="roleData.roleSessionConfig"
      :loading="isLoading"
      :saving="isSaving"
      @save="saveSessionPolicies"
    />
  </entity-detail-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

const DEFAULT_TAB = {
  key: 'session-policies',
  label: 'Políticas de sesión',
  slug: 'politicas-de-sesion'
}

export default {
  name: 'RoleDetail',
  mixins: [mixins],
  components: {
    EntityDetailLayout: () => import('@/components/EntityDetail/EntityDetailLayout.vue'),
    EntityTabs: () => import('@/components/EntityDetail/EntityTabs.vue'),
    RoleSessionPolicies: () => import('@/components/Roles/RoleSessionPolicies.vue')
  },
  data () {
    return {
      isLoading: false,
      isSaving: false,
      roleData: {},
      tabActive: DEFAULT_TAB.key,
      tabs: [DEFAULT_TAB]
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    }),
    roleId () {
      return parseInt(this.$route.params.roleId)
    },
    roleName () {
      return this.roleData.id ? this.getRoleName(this.roleData) : '-'
    },
    registeredAt () {
      return this.roleData.createdAt ? this.humanDate(this.roleData.createdAt, 'DD MMMM YYYY', false, 'es') : '-'
    },
    headerDetails () {
      return [
        { label: 'Total de usuarios', value: this.roleData.usersCount || '-' }
      ]
    }
  },
  watch: {
    '$route.params.tabName': {
      immediate: true,
      handler () {
        this.handleRouteParams()
      }
    },
    '$route.params.roleId': {
      immediate: true,
      handler () {
        this.loadRole()
      }
    }
  },
  created () {
    this.$emit('update-title-action', { visible: false })
  },
  methods: {
    ...mapActions(['getRole', 'saveRoleSessionConfig']),
    goBack () {
      this.$router.push({ name: 'profile-roles' })
    },
    async loadRole () {
      if (!this.roleId) {
        this.$router.replace({ name: 'profile-roles' })
        return
      }

      this.isLoading = true
      try {
        const role = await this.getRole({ roleId: this.roleId })

        if (!role) {
          this.$router.replace({ name: 'profile-roles' })
          return
        }

        this.roleData = role
      } finally {
        this.isLoading = false
      }
    },
    changeTab (tab) {
      this.$router.push({
        name: 'profile-role-detail',
        params: {
          ...this.$route.params,
          tabName: tab.slug
        },
        query: this.$route.query
      })
    },
    handleRouteParams () {
      const foundTab = this.tabs.find(tab => tab.slug === this.$route.params.tabName)
      this.tabActive = foundTab ? foundTab.key : DEFAULT_TAB.key

      if (!foundTab && this.$route.params.tabName) {
        this.changeTab(DEFAULT_TAB)
      }
    },
    async saveSessionPolicies (roleSessionConfig, done) {
      this.isSaving = true
      try {
        const response = await this.saveRoleSessionConfig({
          roleId: this.roleId,
          roleSessionConfig
        })

        if (response) {
          await this.loadRole()
          if (typeof done === 'function') done(true)
        } else if (typeof done === 'function') {
          done(false)
        }
      } catch (error) {
        if (typeof done === 'function') done(false)
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
